export default __webpack_public_path__ + "static/media/small-exit.3aada855.svg";